import { Controller } from "@hotwired/stimulus";

const VALUELESS_OPERATORS = ["present", "blank"];
const INPUT_TYPES = { number: "number", date: "date", datetime: "date" };

export default class extends Controller {
  static values = { fields: Object };

  fieldChanged(event) {
    const row = event.target.closest(".nested-form-wrapper");
    const meta = this.fieldsValue[event.target.value];
    const operatorSelect = row.querySelector("[name='f[][operator]']");

    operatorSelect.replaceChildren();
    if (meta) {
      meta.operators.forEach(([label, key]) =>
        operatorSelect.appendChild(this.#option(label, key)),
      );
    }
    this.#renderValueInput(row, meta, meta?.operators[0]?.[1]);
  }

  operatorChanged(event) {
    const row = event.target.closest(".nested-form-wrapper");
    this.#toggleValue(row, event.target.value);
  }

  #renderValueInput(row, meta, operator) {
    const cell = row.querySelector("[data-value-cell]");
    let input;

    if (meta && meta.options.length > 0) {
      input = document.createElement("select");
      meta.options.forEach(([label, value]) =>
        input.appendChild(this.#option(label, value)),
      );
    } else {
      input = document.createElement("input");
      input.type = meta ? INPUT_TYPES[meta.type] || "text" : "text";
      input.placeholder = cell.dataset.placeholder || "";
    }

    input.name = "f[][value]";
    input.className = cell.dataset.inputClass || "";
    cell.replaceChildren(input);
    this.#toggleValue(row, operator);
  }

  #toggleValue(row, operator) {
    const input = row.querySelector("[name='f[][value]']");
    if (!input) return;

    const valueless = VALUELESS_OPERATORS.includes(operator);
    input.hidden = valueless;
    input.disabled = valueless;
  }

  #option(label, value) {
    const option = document.createElement("option");
    option.value = value;
    option.textContent = label;
    return option;
  }
}
